export default "__VITE_ASSET__$NoLVc6t__"